export enum MeterTypeEnum {
    Impulse = 'Impuls-Zähler',
    IR = 'IR-Zähler'
}
